// extracted by mini-css-extract-plugin
module.exports = {"icon":"DownTriangle_icon_1448O"};